import { apiSlice } from "./apiSlice";
import { EXCELUPLOADS_URL } from "../constants";


export const excelUploadApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({


    // Upload questions Excel file
    uploadQuestionsExcel: builder.mutation({
      query: (formData) => ({
        url: `${EXCELUPLOADS_URL}/questions`,

        method: "POST",

        body: formData,
      }),

      invalidatesTags: ["ExcelUpload"],
    }),



    // Get Excel upload history
    getExcelUploads: builder.query({
      query: () => ({
        url: EXCELUPLOADS_URL,
      }),

      providesTags: ["ExcelUpload"],

      keepUnusedDataFor: 5,
    }),



    // Get Excel upload details
    getExcelUploadDetails: builder.query({
      query: (id) => ({
        url: `${EXCELUPLOADS_URL}/${id}`,
      }),

      providesTags: ["ExcelUpload"],

      keepUnusedDataFor: 5,
    }),

    downloadQuestionTemplate: builder.query({
  query: () => ({
    url: `${EXCELUPLOADS_URL}/template`,
    responseHandler: (response) => response.blob(),
  }),
}),


  }),
});


export const {
  useGetExcelUploadsQuery,
  useGetExcelUploadDetailsQuery,
  useUploadQuestionsExcelMutation,
  useDownloadQuestionTemplateQuery,
  useLazyDownloadQuestionTemplateQuery,
} = excelUploadApiSlice;